/* eslint-disable @typescript-eslint/no-redeclare */

/**
 *  CrewBadgeの色
 */
export const CrewBadgeColorClass = {
  Red: 'crew-badge-red',
  Orange: 'crew-badge-orange',
  Yellow: 'crew-badge-yellow',
  LightGreen: 'crew-badge-light-green',
  Green: 'crew-badge-green',
  SkyBlue: 'crew-badge-sky-blue',
  Blue: 'crew-badge-blue',
  Purple: 'crew-badge-purple',
  Pink: 'crew-badge-pink',
  Gray: 'crew-badge-gray',
} as const

export type CrewBadgeColorClass =
  (typeof CrewBadgeColorClass)[keyof typeof CrewBadgeColorClass]

/**
 *  CrewBadgeの反転色
 */
export const CrewBadgeInvertedColorClass = {
  Red: 'crew-badge-red-inverted',
  Orange: 'crew-badge-orange-inverted',
  Yellow: 'crew-badge-yellow-inverted',
  LightGreen: 'crew-badge-light-green-inverted',
  Green: 'crew-badge-green-inverted',
  SkyBlue: 'crew-badge-sky-blue-inverted',
  Blue: 'crew-badge-blue-inverted',
  Purple: 'crew-badge-purple-inverted',
  Pink: 'crew-badge-pink-inverted',
  Gray: 'crew-badge-gray-inverted',
} as const

export type CrewBadgeInvertedColorClass =
  (typeof CrewBadgeInvertedColorClass)[keyof typeof CrewBadgeInvertedColorClass]

/**
 * テーマごとの色定義
 */

/**
 * CrewBadgeInverted（反転色）のHexカラー定義
 * devExtremeのschedulerなどで使用する
 * 元のバッジの色をそのまま引き継ぐのではなく、色味を考慮して、crew-badgeの値（invertedではない）＿を使用している
 */
export const CrewBadgeInvertedColorToHex = {
  [CrewBadgeInvertedColorClass.Red]: { dark: '#eb7e7e', light: '#f2a9a9' },
  [CrewBadgeInvertedColorClass.Orange]: { dark: '#ffbb6d', light: '#ffd29b' },
  [CrewBadgeInvertedColorClass.Yellow]: { dark: '#f2d767', light: '#f8e395' },
  [CrewBadgeInvertedColorClass.LightGreen]: {
    dark: '#c4d67d',
    light: '#d5e3a6',
  },
  [CrewBadgeInvertedColorClass.Green]: { dark: '#7fba97', light: '#a8d1b8' },
  [CrewBadgeInvertedColorClass.SkyBlue]: { dark: '#95cce2', light: '#c3e0ef' },
  [CrewBadgeInvertedColorClass.Blue]: { dark: '#a4b9d5', light: '#c7d4e5' },
  [CrewBadgeInvertedColorClass.Purple]: { dark: '#b7a8d5', light: '#d4c9e4' },
  [CrewBadgeInvertedColorClass.Pink]: { dark: '#f0a7c1', light: '#f7c8d9' },
  [CrewBadgeInvertedColorClass.Gray]: { dark: '#d1d1d1', light: '#e5e5e5' },
} as const

export type CrewBadgeInvertedColorToHex =
  (typeof CrewBadgeInvertedColorToHex)[keyof typeof CrewBadgeInvertedColorToHex]

export const AppointmentDefaultColorHex = {
  dark: '#7295c2', // crew-blue-300
  light: '#a4b9d5', // crew-blue-400
}

/**
 * CrewBadge（通常色）のHexカラー定義
 * devExtremeのschedulerなどで使用する
 * crew-badge-XXX の背景色
 */
export const CrewBadgeColorToHex = {
  [CrewBadgeColorClass.Red]: { dark: '#eb7e7e', light: '#f2a9a9' },
  [CrewBadgeColorClass.Orange]: { dark: '#ffbb6d', light: '#ffd29b' },
  [CrewBadgeColorClass.Yellow]: { dark: '#f2d767', light: '#f8e395' },
  [CrewBadgeColorClass.LightGreen]: { dark: '#c4d67d', light: '#d5e3a6' },
  [CrewBadgeColorClass.Green]: { dark: '#7fba97', light: '#a8d1b8' },
  [CrewBadgeColorClass.SkyBlue]: { dark: '#95cce2', light: '#c3e0ef' },
  [CrewBadgeColorClass.Blue]: { dark: '#a4b9d5', light: '#c7d4e5' },
  [CrewBadgeColorClass.Purple]: { dark: '#b7a8d5', light: '#d4c9e4' },
  [CrewBadgeColorClass.Pink]: { dark: '#f0a7c1', light: '#f7c8d9' },
  [CrewBadgeColorClass.Gray]: { dark: '#d1d1d1', light: '#e5e5e5' },
} as const

export type CrewBadgeColorToHex =
  (typeof CrewBadgeColorToHex)[keyof typeof CrewBadgeColorToHex]
